<div [formGroup]="form">
    <span *ngIf="label">{{label}}</span>
    <ng2-flatpickr #pickr [ngClass]="'firstsecond'" [config]="config" formControlName="{{name}}"></ng2-flatpickr>
</div>